module.exports = __webpack_public_path__ + "img/FAQ04.71cb8439.png";